import styled from '@emotion/styled';

export const TableContainer = styled.div`
    overflow-x: auto;
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: 8px;
`;

export const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
`;

export const TableHead = styled.thead`
    background-color: ${({ theme }) => theme.color.white100};
`;

export const HeaderCell = styled.th`
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    color: ${({ theme }) => theme.color.black400};
    border-bottom: 2px solid ${({ theme }) => theme.color.grey200};
    white-space: nowrap;
    min-width: 160px;

    &:first-of-type {
        min-width: 200px;
    }
`;

export const HeaderZoneName = styled.div`
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.color.black200};
`;

export const HeaderZoneMeta = styled.div`
    font-size: 11px;
    font-weight: 400;
    color: ${({ theme }) => theme.color.black400};
    margin-top: 2px;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
    &:not(:last-child) {
        border-bottom: 1px solid ${({ theme }) => theme.color.grey200};
    }

    &:hover {
        background-color: ${({ theme }) => theme.color.white200};
    }
`;

export const GroupCell = styled.td`
    padding: 12px 16px;
    vertical-align: top;
`;

export const GroupName = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.color.black200};
`;

export const GroupCode = styled.div`
    font-size: 11px;
    font-weight: 600;
    color: ${({ theme }) => theme.color.grey500};
    margin-top: 2px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
`;

export const RateCell = styled.td`
    padding: 8px 16px;
    vertical-align: top;
`;

export const RateLine = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 2px 0;
    font-size: 13px;
`;

export const RateIcon = styled.span`
    font-size: 14px;
    width: 20px;
    text-align: center;
`;

export const RateLabel = styled.span`
    color: ${({ theme }) => theme.color.black400};
    min-width: 80px;
`;

export const RateValue = styled.span<{ rateColor: string }>`
    font-weight: 700;
    color: ${({ rateColor }) => rateColor};
    margin-left: auto;
`;

export const EmptyCell = styled.td`
    padding: 12px 16px;
    color: ${({ theme }) => theme.color.black400};
    font-style: italic;
`;
